import type { Asset2TranscodingStatus } from '../../../../../apis/graphql';
import { PillColor } from '../../../../../common/Pill';

export function getTranscodePillColorForAsset2(transcodeStatus: Asset2TranscodingStatus): PillColor | null {
  switch (transcodeStatus) {
    case 'ACCEPTED':
    case 'COMPLETED':
      return PillColor.GREEN;
    case 'PROCESSING':
    case 'PUBLISHING':
      return PillColor.YELLOW;
    case 'FAILED':
    case 'REJECTED':
      return PillColor.RED;
    default:
      return null;
  }
}
